import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import id from 'vee-validate/dist/locale/id.json'
import en from 'vee-validate/dist/locale/en.json'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  const validation = {
    en: {
      fields: {
        name: 'Name',
        email: 'Email',
        emailorphone: 'Email or Phone number',
        current_email: 'E-mail',
        current_password: 'Password',
        password: 'Password',
        phone: 'Phone number',
        current_phone: 'Phone number',
        note: 'Note',
        no_meja: 'No. Table',
        otp_type_email: 'Email',
        otp_type_phone: 'Phone',
        credit_card: 'Credit card',
        credit_card_cvn: 'CVV',
        reserve_time: 'Time'
      },
      validation: Object.assign({}, en.messages)
    },
    id: {
      fields: {
        name: 'Nama',
        email: 'Email',
        emailorphone: 'Email atau No. handphone',
        current_email: 'Email',
        current_password: 'Kata sandi',
        password: 'Kata sandi',
        phone: 'No. handphone',
        current_phone: 'No. handphone saat ini',
        note: 'Catatan',
        no_meja: 'Nomor meja',
        otp_type_email: 'Email',
        otp_type_phone: 'Phone',
        credit_card: 'Kartu kredit',
        credit_card_cvn: 'CVV',
        reserve_time: 'Waktu'
      },
      validation: Object.assign({}, id.messages)
    }
  }

  const data = {}
  data.en = { ...validation.en, ...messages.en }
  data.id = { ...validation.id, ...messages.id }
  return data
}

const i18n = new VueI18n({
  locale: Cookies.get(process.env.VUE_APP_COOKIE_LOCALE_KEY + '_Locale') || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: Cookies.get(process.env.VUE_APP_COOKIE_LOCALE_KEY + '_Locale') || process.env.VUE_APP_I18N_LOCALE,
  messages: loadLocaleMessages()
})

// export const t = i18n.global.t.bind(i18n.global);
export const t = i18n.t;

export default i18n
